<div
  class="unauthorized-wrapper"
  [ngClass]="{ 'transparent-bg': transparentBackground }"
>
  <mat-card class="unauthorized-card">
    <div class="icon-wrapper">
      <img src="../../../assets/icons/svg/lock-blue.svg" alt="Lock icon" />
    </div>

    <h1 class="title">You don't have access to this feature</h1>

    <p class="message">
      The action or page you tried to open requires additional permissions that
      are not currently assigned to your account.
    </p>

    <p class="hint">
      If you believe you should have access, please contact your administrator
      and share what you were trying to do.
    </p>

    <div class="actions">
      <button color="primary" (click)="goHome()" class="home-button">
        Go to home
      </button>

      <button type="button" class="contact-button" (click)="contactAdmin()">
        Contact administrator
      </button>
    </div>
  </mat-card>
</div>
